<template>
  <div>
    <div class="text-center" v-if="r.mail_type==5&&!r.content_info">
      <Loading></Loading>
    </div>
    <iframe :class="r.content_info&&loaded1?'':'iframe'" :id="`myIframe${r.id}`" loading="lazy"
            :width="width"
            :height="height"
            :srcdoc="r.content_info">
    </iframe>
<!--    <iframe :class="r.content_info&&loaded1?'':'iframe'" :id="`myIframe${r.id}`" loading="lazy" :width="width"-->
<!--            scrolling="no"-->
<!--            onload="this.style.height=(this.contentWindow.document.body.scrollHeight)+'px'"-->
<!--            :srcdoc="r.content_info">-->
<!--    </iframe>-->
    <el-col style="flex:1;border-right: 1px solid #D7D7D7;padding-right: 30px;" :xs="24" :lg="19" :md="18" :sm="24">
      <template v-if="r.package_content">
        <div class="product-container" v-if="r.package_content.confirm && r.package_content.confirm.length">
          <div class="product-wrapper">
            <div class="product-wrapper-left">
              <div class="product-item" v-for="(item,index) in r.package_content.confirm" :key="index">
                <div>
                  <img :src="item.img || item.picture" style="width:120px;height:120px;object-fit: contain;"/>
                </div>
                <div class="product-detail">
                  <div class="product-name">
                    <p>{{ item.name }}</p>
                  </div>
                  <p v-for="(d,didx) in item.good_detail_arr" :key="didx">{{ d }}</p>
                  <p v-if="item.price_detail && JSON.parse(item.price_detail).price" class="product-price">
                    <label :class="{'danger':JSON.parse(item.price_detail).discounted_price}">{{
                      JSON.parse(item.price_detail).discounted_price || JSON.parse(item.price_detail).price}}</label>
                    <del style="color:#B0B4BF" v-if="JSON.parse(item.price_detail).discounted_price">{{
                      JSON.parse(item.price_detail).price }}
                    </del>
                  </p>
                </div>
                <!--<div style="padding-left:30px;width:20%;">
                  <el-button class="block btn-14" type="info" @click="updateMail(item)">处理邮件</el-button>
                </div>-->
              </div>
            </div>
            <div class="product-wrapper-right">
              <template v-if="r.tracking_list.length">
                <p style="color:#888888;margin-bottom:10px;">商家物流</p>
                <p>{{ r.tracking_list.join(',') }}</p>
              </template>
            </div>
          </div>
        </div>
        <div class="product-container" v-if="r.package_content.out_of_stock && r.package_content.out_of_stock.length">
          <div class="product-wrapper">
            <div class="product-wrapper-left">
              <div class="product-item" v-for="(item,index) in r.package_content.out_of_stock" :key="index">
                <div>
                  <img :src="item.img || item.picture" style="width:120px;height:120px;object-fit: contain;"/>
                </div>
                <div class="product-detail">
                  <div class="product-name">
                    <p>{{ item.name }}</p>
                  </div>
                  <p v-for="(d,didx) in item.good_detail_arr" :key="didx">{{ d }}</p>
                  <p v-if="item.price_detail && JSON.parse(item.price_detail).price" class="product-price">
                    <label :class="{'danger':JSON.parse(item.price_detail).discounted_price}">{{
                      JSON.parse(item.price_detail).discounted_price || JSON.parse(item.price_detail).price}}</label>
                    <del style="color:#B0B4BF" v-if="JSON.parse(item.price_detail).discounted_price">{{
                      JSON.parse(item.price_detail).price }}
                    </del>
                  </p>
                </div>
                <!--<div style="padding-left:30px;width:20%;">
                  <el-button class="block btn-14" type="info" @click="updateMail(item)">处理邮件</el-button>
                </div>-->
              </div>
            </div>
            <div class="product-wrapper-right">
              <template v-if="r.tracking_list.length">
                <p style="color:#888888;margin-bottom:10px;">商家物流</p>
                <p>{{ r.tracking_list.join(',') }}</p>
              </template>
            </div>
          </div>
        </div>
        <div class="product-container" v-if="r.package_content.shipping_now && r.package_content.shipping_now.length">
          <div class="product-wrapper" v-for="(pack,packindex) in r.package_content.shipping_now" :key="packindex">
            <div class="product-wrapper-left">
              <div class="product-item" v-for="(item,index) in pack.good_list" :key="index">
                <div>
                  <img :src="item.img || item.picture" style="width:120px;height:120px;object-fit: contain;"/>
                </div>
                <div class="product-detail">
                  <div class="product-name">
                    <p>{{ item.name }}</p>
                  </div>
                  <p v-for="(d,didx) in item.good_detail_arr" :key="didx">{{ d }}</p>
                  <p v-if="item.price_detail && JSON.parse(item.price_detail).price" class="product-price">
                    <label :class="{'danger':JSON.parse(item.price_detail).discounted_price}">{{
                      JSON.parse(item.price_detail).discounted_price || JSON.parse(item.price_detail).price }}</label>
                    <del style="color:#B0B4BF" v-if="JSON.parse(item.price_detail).discounted_price">{{
                      JSON.parse(item.price_detail).price }}
                    </del>
                  </p>
                </div>
                <!--<div style="padding-left:30px;width:20%;">
                  <el-button class="block btn-14" type="info" @click="updateMail(item)">处理邮件</el-button>
                </div>-->
              </div>
            </div>
            <div class="product-wrapper-right">
              <p style="margin-bottom:20px;color:#888888">刚发货</p>
              <template
                v-if="pack.mail_tracking_info && (pack.mail_tracking_info.tracking_number || pack.mail_tracking_info.tracking_link)">
                <p style="color:#888888;margin-bottom:10px;">商家物流</p>
                <p v-if="pack.mail_tracking_info.tracking_link" style="white-space: nowrap;">
                  <span style="display: block;margin-bottom:10px;"  v-for="(a,i) in pack.mail_tracking_info.tracking_link.split(',')" :key="i">
                    <i class="el-icon-link" style="position:relative;top:1px;"></i>
                  <a class="content_link" target="_blank" :href="a">{{
                    pack.mail_tracking_info.tracking_number?pack.mail_tracking_info.tracking_number.split(',')[i]:'物流链接'}}</a>
                  </span>

                </p>
                <p v-else>
                  {{ pack.mail_tracking_info.tracking_number}}
                </p>
              </template>
            </div>
          </div>
        </div>
        <div class="product-container"
             v-if="r.package_content.already_shipped && r.package_content.already_shipped.length">
          <div v-for="(pack,packindex) in r.package_content.already_shipped" :key="packindex">
            <div class="product-wrapper">
              <div class="product-wrapper-left">
                <div class="product-item" v-for="(item,index) in pack.good_list" :key="index">
                  <div>
                    <img :src="item.img || item.picture" style="width:120px;height:120px;object-fit: contain;"/>
                  </div>
                  <div class="product-detail">
                    <div class="product-name">
                      <p>{{ item.name }}</p>
                    </div>
                    <p v-for="(d,didx) in item.good_detail_arr" :key="didx">{{ d }}</p>
                    <p v-if="item.price_detail && JSON.parse(item.price_detail).price" class="product-price">
                      <label :class="{'danger':JSON.parse(item.price_detail).discounted_price}">{{
                        JSON.parse(item.price_detail).discounted_price || JSON.parse(item.price_detail).price }}</label>
                      <del style="color:#B0B4BF" v-if="JSON.parse(item.price_detail).discounted_price">{{
                        JSON.parse(item.price_detail).price }}
                      </del>
                    </p>
                  </div>
                </div>
              </div>
              <div class="product-wrapper-right">
                <p style="margin-bottom:20px;color:#888888">已发货</p>
                <template
                  v-if="pack.mail_tracking_info && (pack.mail_tracking_info.tracking_number || pack.mail_tracking_info.tracking_link)">
                  <p style="color:#888888;margin-bottom:10px;">商家物流</p>
                  <p v-if="pack.mail_tracking_info.tracking_link" style="white-space: nowrap;">
                    <i class="el-icon-link" style="position:relative;top:1px;"></i>
                    <a class="content_link" target="_blank" :href="pack.mail_tracking_info.tracking_link">{{
                      pack.mail_tracking_info.tracking_number?pack.mail_tracking_info.tracking_number:'物流链接'}}</a>
                  </p>
                  <p v-else>
                    {{ pack.mail_tracking_info.tracking_number}}
                  </p>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="product-container" v-if="r.package_content.finished && r.package_content.finished.length">
          <div v-for="(pack,packindex) in r.package_content.finished" :key="packindex">
            <div class="product-wrapper">
              <div class="product-wrapper-left">
                <div class="product-item" v-for="(item,index) in pack.good_list" :key="index">
                  <div>
                    <img :src="item.img || item.picture" style="width:120px;height:120px;object-fit: contain;"/>
                  </div>
                  <div class="product-detail">
                    <div class="product-name">
                      <p>{{ item.name }}</p>
                    </div>
                    <p v-for="(d,didx) in item.good_detail_arr" :key="didx">{{ d }}</p>
                    <p v-if="item.price_detail && JSON.parse(item.price_detail).price" class="product-price">
                      <label :class="{'danger':JSON.parse(item.price_detail).discounted_price}">{{
                        JSON.parse(item.price_detail).discounted_price || JSON.parse(item.price_detail).price }}</label>
                      <del style="color:#B0B4BF" v-if="JSON.parse(item.price_detail).discounted_price">{{
                        JSON.parse(item.price_detail).price }}
                      </del>
                    </p>
                  </div>
                </div>
              </div>
              <div class="product-wrapper-right">
                <p style="margin-bottom:20px;color:#888888">已发货</p>
                <template
                  v-if="pack.mail_tracking_info && (pack.mail_tracking_info.tracking_number || pack.mail_tracking_info.tracking_link)">
                  <p style="color:#888888;margin-bottom:10px;">商家物流</p>
                  <p v-if="pack.mail_tracking_info.tracking_link" style="white-space: nowrap;">
                    <i class="el-icon-link" style="position:relative;top:1px;"></i>
                    <a class="content_link" target="_blank" :href="pack.mail_tracking_info.tracking_link">{{
                      pack.mail_tracking_info.tracking_number?pack.mail_tracking_info.tracking_number:'物流链接'}}</a>
                  </p>
                  <p v-else>
                    {{ pack.mail_tracking_info.tracking_number}}
                  </p>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="product-container" v-if="r.package_content.arrive_soon && r.package_content.arrive_soon.length">
          <div v-for="(pack,packindex) in r.package_content.arrive_soon" :key="packindex">
            <div class="product-wrapper">
              <div class="product-wrapper-left">
                <div class="product-item" v-for="(item,index) in pack.good_list" :key="index">
                  <div>
                    <img :src="item.img || item.picture" style="width:120px;height:120px;object-fit: contain;"/>
                  </div>
                  <div class="product-detail">
                    <div class="product-name">
                      <p>{{ item.name }}</p>
                    </div>
                    <p v-for="(d,didx) in item.good_detail_arr" :key="didx">{{ d }}</p>
                    <p v-if="item.price_detail && JSON.parse(item.price_detail).price" class="product-price">
                      <label :class="{'danger':JSON.parse(item.price_detail).discounted_price}">{{
                        JSON.parse(item.price_detail).discounted_price || JSON.parse(item.price_detail).price }}</label>
                      <del style="color:#B0B4BF" v-if="JSON.parse(item.price_detail).discounted_price">{{
                        JSON.parse(item.price_detail).price }}
                      </del>
                    </p>
                  </div>
                </div>
              </div>
              <div class="product-wrapper-right">
                <p style="margin-bottom:20px;color:#888888">已发货</p>
                <template
                  v-if="pack.mail_tracking_info && (pack.mail_tracking_info.tracking_number || pack.mail_tracking_info.tracking_link)">
                  <p style="color:#888888;margin-bottom:10px;">商家物流</p>
                  <p v-if="pack.mail_tracking_info.tracking_link" style="white-space: nowrap;">
                    <i class="el-icon-link" style="position:relative;top:1px;"></i>
                    <a class="content_link" target="_blank" :href="pack.mail_tracking_info.tracking_link">{{
                      pack.mail_tracking_info.tracking_number?pack.mail_tracking_info.tracking_number:'物流链接'}}</a>
                  </p>
                  <p v-else>
                    {{ pack.mail_tracking_info.tracking_number}}
                  </p>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="product-container" v-if="r.package_content.shipping_soon && r.package_content.shipping_soon.length">
          <div class="product-wrapper">
            <div class="product-wrapper-left">
              <div class="product-item" v-for="(item,index) in r.package_content.shipping_soon" :key="index">
                <div>
                  <img :src="item.img || item.picture" style="width:120px;height:120px;object-fit: contain;"/>
                </div>
                <div class="product-detail">
                  <div class="product-name">
                    <p>{{ item.name }}</p>
                  </div>
                  <p v-for="(d,didx) in item.good_detail_arr" :key="didx">{{ d }}</p>
                  <p v-if="item.price_detail && JSON.parse(item.price_detail).price" class="product-price">
                    <label :class="{'danger':JSON.parse(item.price_detail).discounted_price}">{{
                      JSON.parse(item.price_detail).discounted_price || JSON.parse(item.price_detail).price }}</label>
                    <del style="color:#B0B4BF" v-if="JSON.parse(item.price_detail).discounted_price">{{
                      JSON.parse(item.price_detail).price }}
                    </del>
                  </p>
                </div>
              </div>
            </div>
            <div class="product-wrapper-right">
              <p style="margin-bottom:20px;color:#888888">待发货</p>
            </div>
          </div>
        </div>
        <div class="product-container" v-if="r.package_content.cancel && r.package_content.cancel.length">
          <div class="product-wrapper">
            <div class="product-wrapper-left">
              <div class="product-item" v-for="(item,index) in r.package_content.cancel" :key="index">
                <div>
                  <img :src="item.img || item.picture" style="width:120px;height:120px;object-fit: contain;"/>
                </div>
                <div class="product-detail">
                  <div class="product-name">
                    <p>{{ item.name }}</p>
                  </div>
                  <p v-for="(d,didx) in item.good_detail_arr" :key="didx">{{ d }}</p>
                  <p v-if="item.price_detail && JSON.parse(item.price_detail).price" class="product-price">
                    <label :class="{'danger':JSON.parse(item.price_detail).discounted_price}">{{
                      JSON.parse(item.price_detail).discounted_price || JSON.parse(item.price_detail).price }}</label>
                    <del style="color:#888888" v-if="JSON.parse(item.price_detail).discounted_price">{{
                      JSON.parse(item.price_detail).price }}
                    </del>
                  </p>
                </div>
                <!--<div style="padding-left:30px;width:20%;">
                  <el-button class="block btn-14" type="info" @click="updateMail(item)">处理邮件</el-button>
                </div>-->
              </div>
            </div>
            <div class="product-wrapper-right">
              <p style="margin-bottom:20px;color:#888888">已取消</p>
            </div>
          </div>
        </div>
      </template>
      <div class="product-container" v-if="r.mail_theme=='礼品卡'">
        <div class="product-wrapper">
          <div class="product-wrapper-left lika" :class="{'taskDisplay':taskDisplay}">
            <template v-if="r.link_url">
              <a class="content_link" target="_blank" :href="r.link_url">礼卡链接</a>
            </template>
            <template v-if="r.gift_card_number">
              <p>{{ `${r.gift_card_number} # ${r.gift_card_pin}` }}</p>
            </template>
          </div>
          <div class="product-wrapper-right">
          </div>
        </div>
      </div>
      <div class="product-container" v-if="r.mail_theme.indexOf('优惠码')!=-1||r.mail_theme.indexOf('推荐注册')!=-1">
        <div class="product-wrapper">
          <div class="product-wrapper-left lika" :class="{'taskDisplay':taskDisplay}">
            <template v-if="r.merchant_order_detail">
              <a v-if="r.merchant_order_detail.code_info.href" class="content_link" target="_blank"
                 :href="r.merchant_order_detail.code_info.href">领取您的礼物</a>
              <p style="margin-top: 1rem">
                {{r.merchant_order_detail.code_info.info}}
              </p>
              <p>
                {{r.merchant_order_detail.code_info.code}}
              </p>
            </template>
          </div>
          <div class="product-wrapper-right">
          </div>
        </div>
      </div>
      <div class="product-container" :id="`myIframe2${r.id}`" v-if="r.mail_type==5&&!loaded1">
        邮件内容加载中...
      </div>
    </el-col>
    <el-col v-if="r.mail_type!=5" style="padding-left:50px;" :span="5">
      <!--<div>
        <el-select v-loading="r.updating" style="width:100%;margin-bottom: 20px;" v-model="r.status" :disabled="r.updating"
          class="input-width middle-text" :class="{'black':r.status==2}" @change="updateMail(index)">
          <el-option label="已处理" value="1"></el-option>
          <el-option label="待处理" value="2"></el-option>
        </el-select>
      </div>-->
      <div>
        <template v-if="r.good_number==1">
          <el-popover trigger="hover" placement="bottom">
            <div style="line-height: 1;color:#303133;">
              <template v-if="r.merchant_order_number">
                <p style="color: rgb(136, 136, 136);margin-bottom: 5px;">订单号</p>
                <template v-if="r.merchant_order_link">
                  <p style="margin-bottom: 10px;">
                    <i class="el-icon-link" style="position:relative;top:1px;"></i>
                    <a class="content_link" target="_blank" :href="r.merchant_order_link">{{ r.merchant_order_number
                      }}</a>
                  </p>
                </template>
                <template v-else>
                  <p style="margin-bottom: 10px;">{{ r.merchant_order_number }}</p>
                </template>
              </template>
              <p style="color: rgb(136, 136, 136);margin-bottom: 5px;">
                {{ showForward?'收件邮箱':'转发邮箱' }}
              </p>
              <template v-if="r.showFoward">
                <p style="margin-bottom: 10px;">
                  {{ r.forward_mail }}
                  <i v-if="!r.forward_mail && r.forward_mail!=r.receiver[0]" class="el-icon-refresh"
                     style="cursor: pointer;" @click="showForward=!showForward"></i>
                </p>
              </template>
              <template v-else>
                <p style="margin-bottom: 10px;">
                  {{ r.receiver && r.receiver.length?r.receiver[0]:'' }}
                  <i v-if="!r.forward_mail && r.forward_mail!=r.receiver[0]" class="el-icon-refresh"
                     style="cursor: pointer;" @click="showForward=!showForward"></i>
                </p>
              </template>
              <template v-if="r.merchant_order_detail && r.merchant_order_detail.shipping_to">
                <p style="color: rgb(136, 136, 136);margin-bottom: 5px;">收件地址</p>
                <div style="margin-bottom: 10px;" v-html="r.merchant_order_detail.shipping_to"></div>
              </template>
              <template v-if="r.gift_card_payment && r.gift_card_payment.length">
                <p style="color: rgb(136, 136, 136);margin-bottom: 5px;">礼品卡</p>
                <p v-for="(item,index) in r.gift_card_payment" :key="index">
                  {{ item.gift_card_number+' '+item.price_symbol+item.price }}
                </p>
              </template>
<!--              后台修改数据结构取改成多种支付方式-->
<!--              <template v-if="r.merchant_order_detail && r.merchant_order_detail.payment_method">-->
<!--                <p style="color: rgb(136, 136, 136);margin-bottom: 5px;">支付方式</p>-->
<!--                <p>-->
<!--                  {{r.merchant_order_detail.payment_method}}-->
<!--                  {{`${r.merchant_order_detail.payment_account?':&nbsp;&nbsp;'+r.merchant_order_detail.payment_account:''}`}}-->
<!--                  &lt;!&ndash;{{`${r.merchant_order_detail.payment_method?':&nbsp;&nbsp;xxx@163.com'+r.merchant_order_detail.payment_account:''}`}}&ndash;&gt;-->
<!--                </p>-->
<!--              </template>-->
              <template v-if="r.merchant_order_detail && r.merchant_order_detail.payment_info">
                <p style="color: rgb(136, 136, 136);margin-bottom: 5px;">支付方式</p>
                <p v-for="(item,index) in Object.keys(r.merchant_order_detail.payment_info)" :key="index">
                <span v-for="(a,b) in r.merchant_order_detail.payment_info[item]" :key="b">
                  {{ a.text}}
                </span>
                </p>
              </template>
            </div>
            <div slot="reference">
              <template v-if="r.merchant_order_number">
                <p style="color: rgb(136, 136, 136);margin-bottom: 5px;">订单号</p>
                <template v-if="r.merchant_order_link">
                  <p style="margin-bottom: 10px;">
                    <i class="el-icon-link" style="position:relative;top:1px;"></i>
                    <a class="content_link" target="_blank" :href="r.merchant_order_link">{{ r.merchant_order_number
                      }}</a>
                  </p>
                </template>
                <template v-else>
                  <p style="margin-bottom: 10px;">{{ r.merchant_order_number }}</p>
                </template>
              </template>
              <p style="color: rgb(136, 136, 136);margin-bottom: 5px;">
                {{ showForward?'收件邮箱':'转发邮箱' }}
              </p>
              <template v-if="r.showFoward">
                <p style="margin-bottom: 10px;white-space: nowrap;">
                  {{ r.forward_mail }}
                  <i v-if="!r.forward_mail && r.forward_mail!=r.receiver[0]" class="el-icon-refresh"
                     style="cursor: pointer;" @click="showForward=!showForward"></i>
                </p>
              </template>
              <template v-else>
                <p style="margin-bottom: 10px;white-space: nowrap;">
                  {{ r.receiver && r.receiver.length?r.receiver[0]:'' }}
                  <i v-if="!r.forward_mail && r.forward_mail!=r.receiver[0]" class="el-icon-refresh"
                     style="cursor: pointer;" @click="showForward=!showForward"></i>
                </p>
              </template>
              <template v-if="r.merchant_order_detail && r.merchant_order_detail.shipping_to">
                <p style="color: rgb(136, 136, 136);margin-bottom: 5px;">收件地址</p>
                <div slot="reference" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;height:16px;">
                  {{ displayFirstLine(r.merchant_order_detail.shipping_to) }}
                </div>
              </template>
            </div>
          </el-popover>
        </template>
        <template v-else>
          <div>
            <template v-if="r.merchant_order_number">
              <p style="color: rgb(136, 136, 136);margin-bottom: 5px;">订单号</p>
              <template v-if="r.merchant_order_link">
                <p style="margin-bottom: 10px;">
                  <i class="el-icon-link" style="position:relative;top:1px;"></i>
                  <a class="content_link" target="_blank" :href="r.merchant_order_link">{{ r.merchant_order_number
                    }}</a>
                </p>
              </template>
              <template v-else>
                <p style="margin-bottom: 10px;">{{ r.merchant_order_number }}</p>
              </template>
            </template>
            <p style="color: rgb(136, 136, 136);margin-bottom: 5px;">
              {{ showForward?'收件邮箱':'转发邮箱' }}
            </p>
            <template v-if="r.showFoward">
              <p style="margin-bottom: 10px;">
                {{ r.forward_mail }}
                <i v-if="!r.forward_mail && r.forward_mail!=r.receiver[0]" class="el-icon-refresh"
                   style="cursor: pointer;" @click="showForward=!showForward"></i>
              </p>
            </template>
            <template v-else>
              <p style="margin-bottom: 10px;">
                {{ r.receiver && r.receiver.length?r.receiver[0]:'' }}
                <i v-if="!r.forward_mail && r.forward_mail!=r.receiver[0]" class="el-icon-refresh"
                   style="cursor: pointer;" @click="showForward=!showForward"></i>
              </p>
            </template>
            <template v-if="r.merchant_order_detail && r.merchant_order_detail.shipping_to">
              <p style="color: rgb(136, 136, 136);margin-bottom: 5px;">收件地址</p>
              <div style="margin-bottom: 10px;" v-html="r.merchant_order_detail.shipping_to"></div>
            </template>
            <template v-if="r.gift_card_payment && r.gift_card_payment.length">
              <p style="color: rgb(136, 136, 136);margin-bottom: 5px;">支付方式</p>
              <p v-for="(item,index) in r.gift_card_payment" :key="index">
                {{ item.gift_card_number+' '+item.price_symbol+item.price }}
              </p>
            </template>
            <template v-if="r.merchant_order_detail && r.merchant_order_detail.payment_info">
              <p style="color: rgb(136, 136, 136);margin-bottom: 5px;">支付方式</p>
              <p v-for="(item,index) in Object.keys(r.merchant_order_detail.payment_info)" :key="index">
                <span v-for="(a,b) in r.merchant_order_detail.payment_info[item]" :key="b">
                  {{ a.text}}
                </span>
              </p>
            </template>
          </div>
        </template>
      </div>
      <div>

      </div>
    </el-col>

  </div>
</template>

<script>
    import Order from '../list/Order'

    let _ = require('lodash')

    export default {
        name: 'OrderList',
        props: ['r', 'index', 'taskDisplay'],
        components: {
            Order: Order
        },
        data() {
            return {
                showForward: false,
                iframeInfo: '',
                loaded1: true,
                width: '100%',
                height: '800px'
            }
        },
        async mounted() {
        },
        methods: {
            displayFirstLine(str) {
                return str.split("\<br>")[0]
            },
            async updateMail(index) {
                this.$emit('updateMail', index)
            },
        },
        watch: {
            r(val) {
                if (val.mail_type != 5) {
                    return
                }
                let id = 'myIframe' + val.id
                const iframe = document.getElementById(id);
                if (iframe) {
                    const iframeDoc = iframe.contentDocument
                    if (!iframeDoc) {
                        return
                    }
                    iframeDoc.addEventListener('click', function (e) {
                        let url = e.target.src;
                        if (url) {
                            let p = e.target.closest('[href]');
                            if (p) {
                                url = p.href
                            }
                        } else {
                            url = e.target.href;
                        }
                        if (url) {
                            // 在父页面控制新窗口打开
                            window.open(url, '_blank');
                            e.preventDefault(); // 阻止默认行为
                        }
                    });
                    // iframe.onload = () => {
                    //     this.loaded1 = true
                    // };
                }
            },

        }
    }
</script>

<style lang="scss" scoped>
  .content_link {
    color: #303133;
  }

  .product-container {
    padding: 15px 0;
    /*border-bottom: 1px solid #D7D7D7;*/

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      padding-bottom: 0;
      border-bottom: none;
    }

    &.order {
      display: flex;
      justify-content: space-between;
    }
  }

  .product-wrapper {
    display: flex;
    justify-content: space-between;

    .product-wrapper-left.lika {
      margin-left: 237px;

      &.taskDisplay {
        margin-left: 200px;
      }
    }

    .product-wrapper-right {
      text-align: right;
    }

    &:last-child {
      margin-bottom: 0;
    }

    &.order {
      flex: 1;
      border-right: 1px solid #D7D7D7;
      padding-right: 25px;
      line-height: 1;
    }

    .product-wrapper-right.order p {
      color: #888888;
    }
  }

  .product-item {
    display: flex;
    height: 120px;
    margin-bottom: 30px;

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      border-bottom: 0;
      padding-bottom: 0;
      margin-bottom: 0;
    }

    .product-detail {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
      position: relative;
      top: -3px;
      margin-left: 20px;

      .product-name {
        font-size: 14px;
        color: #333333;
      }

      .product-price {
        line-height: 32px;
        color: black;

        label {
          font-size: 18px;
        }
      }

      .product-price del {
        font-size: 16px;
      }
    }
  }

  .product-price label.danger {
    font-size: 18px;
    color: #FF4650;
  }

  .iframe {
    display: none;
  }

  .product-container iframe {
    display: block !important;
  }

</style>



// WEBPACK FOOTER //
// src/pages/orders/mail/MailBody.vue